import {
  isMediaQueueItems,
  MediaQueue,
  MediaQueueItem,
  MediaQueueItemSourceType,
  MediaQueueSource,
} from 'shared/src/api/types'

export const deleteFromQueue = (
  id: number,
  sourceType: MediaQueueItemSourceType,
  { images, instagram, tikTok }: MediaQueue
): MediaQueue => ({
  images: images.filter(
    (item) => !(item.id === id && item.sourceType === sourceType)
  ),
  instagram: deleteFromSource(id, sourceType, instagram),
  tikTok: deleteFromSource(id, sourceType, tikTok),
})

const deleteFromSource = (
  id: number,
  sourceType: MediaQueueItemSourceType,
  source: MediaQueueSource
): MediaQueueSource =>
  isMediaQueueItems(source)
    ? { items: deleteFromItems(id, sourceType, source.items) }
    : source

const deleteFromItems = (
  id: number,
  sourceType: MediaQueueItemSourceType,
  items: MediaQueueItem[]
): MediaQueueItem[] =>
  items.filter((item) => !(item.id === id && item.sourceType === sourceType))
